import { render } from "./StandardList.vue?vue&type=template&id=c2edeea6"
import script from "./StandardList.vue?vue&type=script&lang=js"
export * from "./StandardList.vue?vue&type=script&lang=js"

import "./StandardList.vue?vue&type=style&index=0&id=c2edeea6&lang=scss"

import exportComponent from "E:\\公司项目\\双碳\\gdtt-front\\gdtt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__